import { NoParamEndpointConstructor } from 'interfaces/api.interfaces'

const baseUrl = '/promo-optimizer-settings'

interface Endpoints {
  getHosts: NoParamEndpointConstructor
  getEndpoints: NoParamEndpointConstructor
}

export const promoOptimizerSettingsEndpoints: Endpoints = {
  getHosts: () => `${baseUrl}/hosts`,
  getEndpoints: () => `${baseUrl}/endpoints`,
}
